// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__Voh9D","MainView":"App_MainView__-mO0m"};